import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { EasyPaySubmittedLayout } from 'containers/Premiums/components/EasyPaySubmittedLayout'
import { MyInternalLink } from 'components/MyLink'
import { PayPremiumsLink } from './EasyPaySignupSubmitted'
import { useEvent } from 'hooks/useEvent'

export const EasyPayLink: FC = ({ children }: { children?: ReactNode }) => {
  const { fireEvent } = useEvent('premiumsEasyPay')
  return (
    <MyInternalLink to="/premiums/easy-pay" onClick={(params) => fireEvent('premiums_easypaychangebanksuccess_easypaypage_click', params)}>{children}</MyInternalLink>
  )
}

export const EasyPayEditSubmittedPage: FC = () => {
  const { t } = useTranslation('easyPayEditSubmittedPage')

  return (
    <EasyPaySubmittedLayout
      t={ t }
      whatNextBulletComponents={ { link1: <PayPremiumsLink />, link2: <EasyPayLink /> } }
      pageType='easypaychangebanksuccess'
    />
  )
}
